import parsePhoneNumber from 'libphonenumber-js';
import validator from 'validator';

import Logger from 'utils/Logger';

export const formatPhoneNumber = (phoneNumber: string) => {
  if (typeof phoneNumber !== 'string') {
    Logger.error('phoneNumber is not a string', phoneNumber);
    return '';
  }

  if (!phoneNumber) {
    return '';
  }

  if (!validator.isMobilePhone(phoneNumber)) {
    return phoneNumber;
  }

  const parsedPhoneNumber = parsePhoneNumber(phoneNumber);

  if (!parsedPhoneNumber) {
    return phoneNumber;
  }

  const formattedPhoneNumber = parsedPhoneNumber.formatNational();

  return formattedPhoneNumber;
};